import { useState } from 'react';

const creators = [
  {
    name: 'Myles Leon',
    niche: 'Lifestyle, Fashion & Fitness',
    platforms: ['TikTok', 'Instagram'],
    followers: '56.7K',
    er: '8.50%',
    image: '/images/featured/myles.jpeg',
    imageAlt: 'Myles Leon - Lifestyle, Fashion & Fitness creator',
    brandsImage: '/images/featured/mylesbrands.png',
    brandsAlt: 'Brand collaborations for Myles Leon',
    brandsText: 'Moschino • Shay & Blue • Dove Men • Urban Decay • Pozion • Kiehl\'s • Tribal Chimp • Thesis • Ridge • Asset',
  },
  {
    name: 'Palak Miglani',
    niche: 'Lifestyle & Beauty',
    platforms: ['TikTok'],
    followers: '123.7K',
    er: '3%',
    image: '/images/featured/palak.jpeg',
    imageAlt: 'Palak Miglani - Lifestyle & Beauty creator',
    imageStyle: { objectPosition: 'center 25%' },
    brandsImage: '/images/featured/palakbrands.png',
    brandsAlt: 'Brand partnerships for Palak Miglani',
    brandsText: 'Samsung • Amazon Prime Student • DoorDash • Fenty Beauty • Crayola • Inde Wild • Valentino Beauty • Life360 • Nutpods',
  },
  {
    name: 'Dustin Dela Cruz',
    niche: 'Dance, Fitness & Lifestyle',
    platforms: ['TikTok', 'Instagram'],
    followers: '3.3K',
    er: '18.35%',
    image: '/images/featured/dustin.jpg',
    imageAlt: 'Dustin Dela Cruz - Dance, Fitness & Lifestyle creator',
    brandsImage: '/images/featured/dustinbrands.png',
    brandsAlt: 'Brand collaborations for Dustin Dela Cruz',
    brandsText: 'Lewkin • Disney • UFreeMoving Systems',
  },
];

function CreatorCard({ creator }) {
  const [flipped, setFlipped] = useState(false);

  return (
    <div
      role="button"
      tabIndex={0}
      onClick={() => setFlipped((f) => !f)}
      onKeyDown={(e) => (e.key === 'Enter' || e.key === ' ') && setFlipped((f) => !f)}
      className={`creator-card bg-white rounded-xl sm:rounded-2xl border border-gray-100 p-5 sm:p-6 hover:shadow-lg transition-all duration-200 hover:-translate-y-1 w-full sm:max-w-sm lg:max-w-[420px] mx-auto sm:mx-0 cursor-pointer overflow-hidden ${flipped ? 'flipped' : ''}`}
    >
      <div className="flip-card-inner relative w-full text-left min-h-[420px]">
        {/* Front: visible when not flipped */}
        <div className="flip-card-front" style={{ display: flipped ? 'none' : 'block' }}>
          <div className="w-full h-56 sm:h-64 md:h-72 rounded-lg sm:rounded-xl mb-3 sm:mb-4 overflow-hidden">
            <img src={creator.image} alt={creator.imageAlt} className="w-full h-full object-cover" loading="lazy" style={creator.imageStyle || {}} />
          </div>
          <h3 className="font-display font-semibold text-dark text-lg mb-2">{creator.name}</h3>
          <p className="text-gray-600 text-sm mb-3 font-dm-sans">{creator.niche}</p>
          <div className="flex flex-wrap gap-2 mb-3">
            {creator.platforms.map((p) => (
              <span key={p} className="px-3 py-1 bg-gray-100 text-gray-700 text-xs rounded-full font-medium font-dm-sans">{p}</span>
            ))}
          </div>
          <div className="mt-4 pt-3 border-t border-gray-100 grid grid-cols-2 gap-y-2">
            <div className="text-sm text-gray-500 font-dm-sans">Followers</div>
            <div className="text-sm font-semibold text-dark font-dm-sans text-right tabular-nums whitespace-nowrap">{creator.followers}</div>
            <div className="text-sm text-gray-500 font-dm-sans">Typical ER</div>
            <div className="text-sm font-semibold text-accent font-dm-sans text-right tabular-nums whitespace-nowrap">{creator.er}</div>
          </div>
        </div>
        {/* Back: visible when flipped */}
        <div className="flip-card-back bg-white p-5 sm:p-6 flex flex-col" style={{ display: flipped ? 'flex' : 'none' }}>
          <div className="w-full h-56 sm:h-64 md:h-72 rounded-lg sm:rounded-xl mb-3 sm:mb-4 overflow-hidden bg-gray-50 flex items-center justify-center">
            <img src={creator.brandsImage} alt={creator.brandsAlt} className="w-full h-full object-contain" loading="lazy" />
          </div>
          <h3 className="font-display font-semibold text-dark text-lg mb-2">Past Brand Collabs</h3>
          <p className="text-gray-600 text-sm mb-3 font-dm-sans flex-1">{creator.brandsText}</p>
          <p className="text-xs text-gray-500 font-dm-sans text-center mt-2">Click to flip back</p>
        </div>
      </div>
    </div>
  );
}

export default function CreatorFlipCards() {
  return (
    <section id="featured-creators" className="py-8 sm:py-12 bg-blue-100/30">
      <div className="container px-4 sm:px-6">
        <div className="text-center mb-12 sm:mb-16 md:mb-20">
          <h2 className="text-2xl sm:text-3xl md:text-4xl font-display font-semibold text-dark mb-4 sm:mb-6 tracking-tight px-2">
            Professional Creator Profile Examples
          </h2>
          <p className="text-base sm:text-lg md:text-xl lg:text-2xl text-gray-600 max-w-3xl mx-auto font-dm-sans font-normal leading-relaxed px-4">
            Real creators using InfluenceHub to build professional creator profiles and showcase their influencer media kits.
          </p>
        </div>
        <div className="grid w-full grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 sm:gap-8 mb-12 sm:mb-16 max-w-6xl mx-auto items-start">
          {creators.map((creator) => (
            <CreatorCard key={creator.name} creator={creator} />
          ))}
        </div>
        <div className="text-center mt-12 sm:mt-16 px-4">
          <a href="/signup" className="w-full sm:w-auto bg-primary text-white px-8 sm:px-12 py-4 sm:py-5 rounded-xl sm:rounded-2xl text-base sm:text-lg font-semibold hover:bg-primary/90 transition-all duration-200 shadow-lg hover:shadow-xl inline-block font-dm-sans min-h-[48px] flex items-center justify-center mx-auto">
            Create your profile
          </a>
          <p className="text-xs sm:text-sm text-gray-500 mt-4 font-dm-sans max-w-2xl mx-auto">
            Build your professional creator profile and start sharing it with brands today.
          </p>
        </div>
      </div>
    </section>
  );
}
